export default function renderIcon({
  width = "18",
  height = "18",
  color = "#FFFFFF",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" fill={color} />
    </svg>
  );
}
